import { Container } from '@algbra/ui/components/Grid/Grid'
import Whitespace from '@algbra/ui/components/Whitespace/Whitespace'
import { graphql, useStaticQuery } from 'gatsby'
import { mapIndexed } from 'rambdax'
import {
  getComponentByZoneType,
  ZoneItemType,
} from '../../zones/MainContentZone'
import styles from './ContactBox.module.scss'

export const QUERY_CONTACT_DETAILS = graphql`
  {
    strapiGQL {
      contactInformation {
        contentZones {
          __typename
          ... on StrapiGQL_ComponentZonesContactBox {
            id
            title
            description
            footnote
            links {
              iconType
              id
              label
              url
            }
            image {
              id
              url
              ext
              resolved {
                childImageSharp {
                  gatsbyImageData(
                    layout: CONSTRAINED
                    formats: WEBP
                    webpOptions: { quality: 100 }
                  )
                }
              }
            }
          }
          ... on StrapiGQL_ComponentZonesFieldset {
            id
            title
            description
            details {
              description
              id
              title
            }
          }
        }
      }
    }
  }
`

export type ZoneContactBoxListProps = {
  __typename: 'StrapiGQL_ComponentZonesContactInfoBoxList'
  title: string
}

export default function ZoneContactBoxList(props: ZoneContactBoxListProps) {
  const {
    strapiGQL: { contactInformation },
  } = useStaticQuery(QUERY_CONTACT_DETAILS)
  return (
    <Whitespace type="md" title={props.title}>
      <Container>
        <div className={styles.boxList}>
          {mapIndexed(
            (zone, index) => (
              <div
                className={styles.box}
                key={`col-${zone.__typename}-${index}`}
              >
                {getComponentByZoneType(zone, `${zone.__typename}-${index}`)}
              </div>
            ),
            (contactInformation.contentZones || []) as ZoneItemType[]
          )}
        </div>
      </Container>
    </Whitespace>
  )
}
